var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-container',{staticClass:"container"},[_c('faq-popular',{attrs:{"inner-data":_vm.innerData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }